import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function PageWrap({ children, size, maxWidth }) {
  const className = cx('pageWrap', `pageWrap-${size}`);
  const style = maxWidth && { maxWidth };
  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
}

PageWrap.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.number,
  size: PropTypes.oneOf(['l', 'm', 's']),
};

PageWrap.defaultProps = {
  size: 'l',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-page-wrap/PageWrap/index.js